<template>
  <div class="base_box">
    <!--  登录 -->
    <div class="login_box animated flipInY" v-show="changeFlag">
      <div class="title card animated fadeIn">
        <img src="@/assets/img/logo.png" alt="">
        <!-- 欢迎登录 -->
        {{$t("login.welcomeL")}}
      </div>
      <div class="body card animated fadeIn">
        <el-form :model="user" :rules="rules" ref="userForm" label-width="7rem">
          <!-- 用户名 -->
          <el-form-item :label='$t("login.username")' prop="name">
            <el-input size="small" maxlength="16" prefix-icon="el-icon-user" v-model="user.name" clearable></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item :label='$t("login.password")' prop="password">
            <el-input size="small" maxlength="16" prefix-icon="el-icon-lock" type="password" v-model="user.password" show-password></el-input>
          </el-form-item>
          <div class="check_box">
            <!--    "t1":"向右拖动滑块填充拼图", -->
            <slide-verify class="check_img" :l="36" :r="6" :w="280" :h="120" :imgs="picArray" @success="onSuccess" @fail="onFail" @refresh="onRefresh" :slider-text='$t("login.t9")'>
            </slide-verify>
          </div>
          <el-form-item>
            <!-- 重 置 -->
            <el-button size="small" @click="resetForm('userForm')">{{$t("login.reset")}}</el-button>
            <!-- 登 录 -->
            <el-button size="small" type="primary" @click="loginFun('userForm')" :disabled="checkFlag">{{$t("login.login")}}</el-button>
          </el-form-item>
          <!-- 游客登陆 -->
          <div class="regist" @click="visitor">{{$t("login.visitor")}}</div>
          <!-- 去注册 -->
          <div class="regist"><span @click="changeBtn()">{{$t("login.toregister")}}</span></div>
        </el-form>
      </div>
    </div>
    <!--  注册 -->
    <div class="login_box animated flipInY" v-show="!changeFlag">
      <!-- 欢迎注册 -->
      <div class="title card animated fadeIn"> <img src="@/assets/img/logo.png" alt="">{{$t("login.welcomeR")}}</div>
      <div class="body card animated fadeIn">
        <el-form :model="regUser" :rules="rules" ref="userRegForm" label-width="6rem">
          <!-- 用户名 -->
          <el-form-item :label='$t("login.username")' prop="name">
            <el-input size="small" maxlength="16" prefix-icon="el-icon-user" v-model="regUser.name" clearable></el-input>
          </el-form-item>
          <!-- 邮箱 -->
          <el-form-item :label='$t("login.email")' prop="email">
            <el-input size="small" maxlength="30" prefix-icon="el-icon-message" v-model="regUser.email"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item :label='$t("login.password")' prop="password">
            <el-input size="small" maxlength="16" prefix-icon="el-icon-lock" type="password" v-model="regUser.password" show-password></el-input>
          </el-form-item>
          <!-- 密码确认 -->
          <el-form-item :label='$t("login.sureP")' prop="check">
            <el-input size="small" maxlength="16" prefix-icon="el-icon-lock" type="password" v-model="regUser.check" show-password></el-input>
          </el-form-item>
          <div class="check_box">
            <!-- 向右拖动滑块填充拼图 -->
            <slide-verify class="check_img" :l="36" :r="6" :w="280" :h="120" :imgs="picArray" @success="onSuccess" @fail="onFail" @refresh="onRefresh" :slider-text='$t("login.t9")'>
            </slide-verify>
          </div>
          <el-form-item>
            <!-- 重 置 -->
            <el-button size="small" @click="resetForm('userRegForm')">{{$t("login.reset")}}</el-button>
            <!-- 注 册 -->
            <el-button size="small" type="primary" @click="regForm('userRegForm')" :disabled="checkFlag">{{$t("login.register")}}</el-button>
          </el-form-item>
          <!-- 去登录 -->
          <div class="regist"><span @click="changeBtn()">{{$t("login.tologin")}}</span></div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const checkEmail = (rule, value, callback) => {
      //验证邮箱
      let check =
        /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
      if (check.test(value)) {
        callback();
      } else {
        // 邮箱格式不正确
        callback(new Error(this.$t("login.t1")));
      }
    };
    const checkPassword = (rule, value, callback) => {
      if (value === "") {
        // 请再次输入密码
        callback(new Error(this.$t("login.t2")));
      } else if (this.regUser.password != value) {
        // 输入密码不一致
        callback(new Error(this.$t("login.t3")));
      } else {
        callback();
      }
    };
    return {
      changeFlag: true, // 注册登录切换
      checkFlag: true, //滑动验证
      picArray: [
        require("@/assets/img/checkImg/check_1.png"),
        require("@/assets/img/checkImg/check_2.png"),
        require("@/assets/img/checkImg/check_3.png"),
        require("@/assets/img/checkImg/check_4.png"),
        require("@/assets/img/checkImg/check_5.png"),
        require("@/assets/img/checkImg/check_6.png"),
        require("@/assets/img/checkImg/check_7.png"),
        require("@/assets/img/checkImg/check_8.png"),
        require("@/assets/img/checkImg/check_9.png"),
        require("@/assets/img/checkImg/check_10.png"),
      ],
      user: {
        name: "",
        password: "",
      },

      regUser: {
        name: "",
        email: "",
        password: "",
        check: "",
      },

      rules: {
        name: [
          // 请输入用户名
          { required: true, message: this.$t("login.t4"), trigger: "blur" },
          // 超过最大字符限制
          { min: 1, max: 16, message: this.$t("login.t5"), trigger: "blur" },
        ],
        email: [
          // 请输入邮箱
          { required: true, message: this.$t("login.t6"), trigger: "blur" },
          { validator: checkEmail, trigger: "blur" },
        ],
        check: [
          // 请再次输入密码
          { required: true, message: this.$t("login.t2"), trigger: "blur" },
          { validator: checkPassword, trigger: "blur" },
        ],
        password: [
          // 请输入密码
          { required: true, message: this.$t("login.t6"), trigger: "blur" },
          // 密码小于不能小于6位
          { min: 6, max: 16, message: this.$t("login.t8"), trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    visitor() {
      this.user.name = "visitor";
      this.user.password = "visitor";
      this.loginFun("userForm");
    },
    loginFun(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let pardata = {
            userAccount: this.user.name,
            userPassword: this.common.encrypt(this.user.password),
            systemFlag: "1", //1用户系统， 2管理系统
          };
          this.$Loading.show();
          this.http.post("/user/login", pardata).then((res) => {
            this.$Loading.hide();
            if (res.code == "0") {
              //存储用户信息
              sessionStorage.setItem("user", JSON.stringify(res.data));
              sessionStorage.setItem("path", 1); //地图页面路径标记
              this.$message({
                message: "登录成功",
                type: "success",
              });
              this.$router.push("/map");
            } else {
              this.$message.error(res.message + "," + res.description);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 注册
    regForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let pardata = {
            userAccount: this.regUser.name,
            email: this.regUser.email,
            userPassword: this.common.encrypt(this.regUser.password),
            checkPassword: this.common.encrypt(this.regUser.check),
            systemFlag: "1", //1用户系统， 2管理系统
          };
          this.$Loading.show();
          this.http.post("/user/register", pardata).then((res) => {
            this.$Loading.hide();
            if (res.code == "0") {
              this.changeFlag = true;
              this.user.name = this.regUser.name;
              this.$message({
                message: "注册成功",
                type: "success",
              });
            } else {
              this.$message.error(res.message + "," + res.description);
            }
          });
        } else {
          return false;
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    changeBtn() {
      this.checkFlag = true;
      if (this.changeFlag) {
        this.regUser = {
          name: "",
          password: "",
          check: "",
        };
      } else {
        this.user.password = "";
      }

      this.changeFlag = !this.changeFlag;
    },
    // 验证成功
    onSuccess() {
      this.checkFlag = false;
      // console.log("验证成功的回调");
    },
    // 验证失败
    onFail() {
      this.checkFlag = true;
      // console.log("验证失败的回调");
    },
    // 按钮刷新
    onRefresh() {
      this.checkFlag = true;
      // console.log("按钮刷新的回调");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_common.scss";

.base_box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/img/banner.jpg") no-repeat fixed center;
  background-size: auto 100%;
}

.login_box {
  width: 30rem;
  border-radius: $r-mid;
  padding: $m-mid;
  //玻璃质感
  background-color: $c-glass;
  backdrop-filter: $d-glass;
  border: $b-glass;
  box-shadow: $shadow;

  .title {
    width: 80%;
    margin: 0 auto;
    margin: $m-lit auto;
    padding: $m-mid;
    text-align: center;
    font-size: $f-hug;
    color: $c-main;
    display: flex;
    //  flex-direction: column ;
    align-items: center;
    justify-content: center;
    img {
      margin-right: $m-lit;
      width: 3rem;
      height: 3rem;
    }
  }
  .body {
    width: 80%;
    margin: 0 auto;
    margin: $m-lit auto;
    padding: $m-mid;
    .el-form {
      .el-form-item {
        color: $c-text-white;
        margin: $m-min;
        .el-input {
        }
      }
      .el-button {
        width: 40%;
      }
    }
    .regist {
      font-size: $f-lit;
      color: $c-main;
      text-align: right;
      margin-top: 0.2rem;
      cursor: pointer;
      &:hover {
        color: $c-second;
      }
    }
    .check_box {
      margin-top: $m-big;
      display: flex;
      justify-content: center;
      .check_img {
        border-radius: 0.2rem;
        overflow: hidden;
      }
    }
  }
}

@media screen and (min-width: 451px) and (max-width: 650px) {
  .login_box {
    width: 25rem;
  }
}
</style>
